import React from 'react';
import PropTypes from 'prop-types';

const QuotesIcon = ({ className, size = 16, ...props }) => (
  <svg {...props} className={className} width={size} height={size}>
    <path
      fill="none"
      fillRule="evenodd"
      // eslint-disable-next-line max-len
      d="M49.349 3.021c2.1 2.015 3.151 4.546 3.151 7.59 0 1.573-.252 3.168-.75 4.789-.502 1.621-1.403 3.758-2.702 6.41L39.298 42h-10.5l6-22.547c-3.1-2.26-4.65-5.207-4.65-8.842 0-2.948 1.1-5.453 3.3-7.516C35.649 1.032 38.299 0 41.399 0c3.2 0 5.852 1.01 7.95 3.021m-28.723 0c2.148 2.015 3.224 4.546 3.224 7.59 0 1.573-.251 3.168-.75 4.789-.502 1.621-1.403 3.758-2.7 6.41L10.5 42H0l6.149-22.547c-3.203-2.358-4.8-5.306-4.8-8.842 0-2.948 1.099-5.453 3.3-7.516C6.848 1.032 9.498 0 12.599 0c3.199 0 5.873 1.01 8.026 3.021"
    />
  </svg>
);

QuotesIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

export { QuotesIcon };
